<template>
  <component :is="data.component" :key="index" v-bind="data.bind" class="story-background" />
</template>

<script>
import { isVideoSlide, SLIDE_DURATION_MS } from '@base/stories/const'

export default {
  name: 'story-background',
  props: {
    slide: {
      type: Object,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
    isActiveStory: {
      type: Boolean,
    },
    activeSlideIdx: {
      type: Number,
      required: true,
    },
    isPaused: {
      type: Boolean,
    },
  },
  data() {
    return {
      data: {},
      el: null,
      slideType: null, // img | video
    }
  },
  beforeDestroy() {
    this.removeElListeners()
  },
  computed: {
    isVideoSlide() {
      return isVideoSlide(this.slide.type)
    },
  },
  methods: {
    setVideoData() {
      this.data = {
        component: 'video',
        bind: {
          ref: this.index,
          src: `${this.slide.src}/download`,
          width: 500,
          height: 600,
          preload: 'auto',
          playsinline: true,
        },
      }

      this.$nextTick(() => {
        this.el = this.$refs[this.index]
        this.el.addEventListener('error', this.errorAction)
        this.el.addEventListener('waiting', this.waitingVideoAction)
        this.el.addEventListener('canplaythrough', this.canplaythroughVideoAction, { once: true })
      })
    },
    errorAction(e) {
      console.error('Ошибка загрузки:', e, this.data)

      if (this.el.error) {
        console.error('MediaError code:', this.el.error.code)
        console.error('MediaError message:', this.el.error.message || '(нет сообщения)')
      }

      this.$emit('background:error')
    },
    stopVideo() {
      if (this.el) {
        this.el.pause()
        this.el.currentTime = 0
      }
    },
    waitingVideoAction() {
      if (!this.isPaused) this.$emit('background:waiting')
    },
    canplaythroughVideoAction() {
      this.el.loop = true
      const duration = this.el.duration * 1000
      this.$emit('duration:set', this.index, duration)
      if (this.isActiveStory) this.$emit('background:loaded')
    },
    setImgData() {
      this.data = {
        component: 'img',
        bind: {
          ref: this.index,
          src: this.slide.src,
          alt: this.slide.title,
        },
      }

      this.$nextTick(() => {
        this.el = this.$refs[this.index]

        this.el.addEventListener('error', this.errorAction)
        this.el.addEventListener('load', this.loadedImageAction, { once: true })
      })
    },
    loadedImageAction() {
      this.$emit('duration:set', this.index, SLIDE_DURATION_MS)
      if (this.isActiveStory) this.$emit('background:loaded')
    },
    removeElListeners() {
      if (!this.el) return

      this.el.removeEventListener('error', this.errorAction)

      if (this.slideType === 'video') {
        this.stopVideo()
        this.el.removeEventListener('waiting', this.waitingVideoAction)
        this.el.removeEventListener('canplaythrough', this.canplaythroughVideoAction)
      } else this.el.removeEventListener('load', this.loadedImageAction)
    },
  },
  watch: {
    'slide.id': {
      handler() {
        if (this.el) {
          this.removeElListeners()
        }

        this.el = null

        if (this.isVideoSlide) {
          this.slideType = 'video'
          this.setVideoData()
        } else {
          this.slideType = 'img'
          this.setImgData()
        }
      },
      immediate: true,
    },
    isActiveStory(v) {
      if (!v && this.isVideoSlide) this.stopVideo()
    },
    isPaused(v) {
      if (this.isVideoSlide && this.el) {
        if (v) this.el.pause()
        else this.el.play()
      }
    },
  },
}
</script>

<style lang="sass">
.story-background
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  object-position: center
  object-fit: cover
  z-index: -2
</style>



// WEBPACK FOOTER //
// src/templates/components/base/stories/components/StoryBackground.vue